import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("azu_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const currentPath = window.location.pathname;
      if (currentPath.startsWith("/admin") && currentPath !== "/admin/login") {
        localStorage.removeItem("azu_token");
        localStorage.removeItem("azu_user");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export function fileUrl(storagePath) {
  if (!storagePath) return null;
  return `${API_BASE}/files/${storagePath}`;
}

/**
 * Baixa um PDF de rota autenticada (envia Bearer token) e abre/baixa como Blob.
 * @param {string} path — endpoint relativo, ex: "/admin/contracts/abc/pdf"
 * @param {"inline"|"download"} mode — "inline" abre em nova aba, "download" força download
 * @param {string} filename — nome sugerido do arquivo
 */
export async function downloadAuthenticatedPdf(path, mode = "inline", filename = "documento.pdf") {
  const token = localStorage.getItem("azu_token");
  const resp = await fetch(`${API_BASE}${path}`, {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/pdf",
    },
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(text || `Falha ao carregar PDF (HTTP ${resp.status})`);
  }
  const blob = await resp.blob();
  const objectUrl = URL.createObjectURL(blob);
  if (mode === "download") {
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } else {
    window.open(objectUrl, "_blank", "noopener,noreferrer");
  }
  // Revoga a URL após um pequeno delay (para dar tempo do navegador abrir/baixar)
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}

export default api;
